export default "__VITE_ASSET__BQ_Cif72__"